/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Scope_Org_HintInputs */



/**
* | output |
* | --- |
* | "Everyone in your organization can see and run this agent." |
*
* @param {Agent_Builder_Scope_Org_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_scope_org_hint = /** @type {((inputs?: Agent_Builder_Scope_Org_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Scope_Org_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle in Ihrer Organisation sehen und starten diesen Agenten.")
	return /** @type {LocalizedString} */ ("Everyone in your organization can see and run this agent.")
});